/**
 * TrustFactsStrip — displays only genuine, verifiable facts (never a
 * star rating, review count, "as seen in" logo, or testimonial). Renders
 * a simple wrapped row of small text chips plus an optional "reviewed"
 * date line. Safe to reuse across any LifeIQ Books series.
 */
export default function TrustFactsStrip({ facts = [], reviewedLabel, accentColor = "#D4A030", textColor = "#5A6B82", dividerColor, testId = "trust-facts-strip" }) {
  if (!facts.length) return null;
  return (
    <div data-testid={testId} className="flex flex-wrap items-center gap-x-3 gap-y-2">
      {facts.map((fact, i) => (
        <span key={fact} className="flex items-center gap-3">
          <span className="text-[12px] sm:text-[13px] font-semibold" style={{ color: textColor }}>{fact}</span>
          {i < facts.length - 1 && (
            <span aria-hidden="true" style={{ color: dividerColor || accentColor }}>·</span>
          )}
        </span>
      ))}
      {reviewedLabel && (
        <span data-testid={`${testId}-reviewed`} className="text-[11px] uppercase tracking-[0.1em] font-semibold ml-1" style={{ color: accentColor }}>
          {reviewedLabel}
        </span>
      )}
    </div>
  );
}
